var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hv-stepper" }, [
    _c("div", { staticClass: "checkoutFakeHeader fixed-top" }, [
      _c("div", { staticClass: "container-max" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "headerStepper" }, [
              _c(
                "ol",
                { staticClass: "step-wrapper d-flex flex-wrap" },
                [
                  _c(
                    "li",
                    {
                      staticClass: "step-item",
                      class: {
                        active: this.activeStep === 1,
                        visited: this.activeStep > 1,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeStep(1)
                        },
                      },
                    },
                    [_vm._t("title-one")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "step-item",
                      class: {
                        active: this.activeStep === 2,
                        visited: this.activeStep > 2,
                        invalid: !this.isAddressValid,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeStep(2)
                        },
                      },
                    },
                    [_vm._t("title-two")],
                    2
                  ),
                  _vm._v(" "),
                  _vm.spcount > 1
                    ? [
                        _c(
                          "li",
                          {
                            staticClass: "step-item",
                            class: {
                              active: this.activeStep === 3,
                              visited: this.activeStep > 3,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeStep(3)
                              },
                            },
                          },
                          [_vm._t("title-three")],
                          2
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "step-item",
                      class: { active: this.activeStep === 4 },
                      on: {
                        click: function ($event) {
                          return _vm.changeStep(4)
                        },
                      },
                    },
                    [_vm._t("title-four")],
                    2
                  ),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-3" }, [
            _c("div", { staticClass: "nextWrapper px-lg-3" }, [
              _vm.activeStep == 1
                ? _c(
                    "a",
                    {
                      staticClass: "next-step",
                      attrs: { href: "/" + _vm.lang + "/checkout" },
                    },
                    [
                      _c("div", { staticClass: "t3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "CeresCoconut::Template.basketNextStepButton"
                            )
                          )
                        ),
                        _c("i", {
                          staticClass: "pl-1 fa fa-chevron-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeStep === 2 || _vm.activeStep === 3
                ? _c(
                    "a",
                    {
                      staticClass: "next-step",
                      on: {
                        click: function ($event) {
                          return _vm.nextStep()
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "t3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "CeresCoconut::Template.basketNextStepButton"
                            )
                          )
                        ),
                        _c("i", {
                          staticClass: "pl-1 fa fa-chevron-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { class: { row: !_vm.isBasket } }, [
      _c(
        "div",
        { class: { "col-lg-7": !_vm.isBasket } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 1,
                  expression: "activeStep === 1",
                },
              ],
              class: { row: _vm.isBasket },
            },
            [_vm._t("step-one")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 2,
                  expression: "activeStep === 2",
                },
              ],
            },
            [_vm._t("step-two")],
            2
          ),
          _vm._v(" "),
          _vm.spcount > 1
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeStep === 3,
                        expression: "activeStep === 3",
                      },
                    ],
                  },
                  [_vm._t("step-three")],
                  2
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 4,
                  expression: "activeStep === 4",
                },
              ],
            },
            [_vm._t("step-four")],
            2
          ),
          _vm._v(" "),
          _vm.activeStep === 2 || _vm.activeStep === 3
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary btn-large btn-appearance btn-next",
                  on: {
                    click: function ($event) {
                      return _vm.nextStep()
                    },
                  },
                },
                [
                  _vm.activeStep === 3 ||
                  (_vm.activeStep === 2 && _vm.spcount === 1)
                    ? [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$translate(
                                "CeresCoconut::Template.checkoutNextBtnTextStep3"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    : [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$translate(
                                "CeresCoconut::Template.checkoutNextBtnText"
                              )
                            ) +
                            "\n          "
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.isBasket
        ? _c(
            "div",
            { staticClass: "col-lg-5" },
            [
              _vm._t("step-right-side"),
              _vm._v(" "),
              _vm.activeStep === 2 || _vm.activeStep === 3
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary btn-large btn-appearance btn-next",
                      on: {
                        click: function ($event) {
                          return _vm.nextStep()
                        },
                      },
                    },
                    [
                      _vm.activeStep === 3 ||
                      (_vm.activeStep === 2 && _vm.spcount === 1)
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "CeresCoconut::Template.checkoutNextBtnTextStep3"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "CeresCoconut::Template.checkoutNextBtnText"
                                  )
                                ) +
                                "\n          "
                            ),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeStep === 4,
                      expression: "activeStep === 4",
                    },
                  ],
                },
                [
                  _c("shipping-privacy-hint-check"),
                  _vm._v(" "),
                  _c("accept-gtc-check", { staticClass: "gtcCheck" }),
                  _vm._v(" "),
                  _vm._t("step-right-side-btn"),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sslEncryption mt-3 text-success" }, [
                _c("span", { staticClass: "h6" }, [
                  _c("i", {
                    staticClass: "fa fa-lock mr-1",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$translate(
                            "CeresCoconut::Template.checkoutSSLConnection"
                          )
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-3" }, [
      _c("div", { staticClass: "brand-wrapper px-lg-3 d-flex flex-fill" }, [
        _c("a", { staticClass: "navbar-brand py-2", attrs: { href: "/" } }, [
          _c("picture", [
            _c("source", {
              attrs: {
                srcset:
                  "https://cdn02.plentymarkets.com/4tnz2nlw17zy/frontend/Logos/LOGO_1.png",
              },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-fluid",
              attrs: {
                src: "https://cdn02.plentymarkets.com/4tnz2nlw17zy/frontend/Logos/LOGO_1.png",
                alt: "Hochwertige Kosmetikspiegel in echter Manufakturqualität auf kosmetikspiegel.shop",
              },
            }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }